import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import * as quotationTermService from "../services/quotationTermService";

export const useQuotationTerms = () => {
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await quotationTermService.getTerms();
            setTerms(res.data.terms || []);
        } catch (err) {
            toast.error("Failed to load quotation terms");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const deleteTerm = async (id) => {
        if (!window.confirm("Are you sure you want to delete this clause?")) return;
        try {
            await quotationTermService.deleteTerm(id);
            toast.success("Clause deleted successfully");
            fetchData();
        } catch (err) {
            toast.error("Failed to delete clause");
        }
    };

    const toggleActive = async (id, currentStatus) => {
        try {
            await quotationTermService.toggleActive(id, !currentStatus);
            setTerms(prev => prev.map(t => t._id === id ? { ...t, isActive: !currentStatus } : t));
            toast.success(`Clause ${!currentStatus ? 'enabled' : 'disabled'}`);
        } catch (err) {
            toast.error("Failed to update status");
        }
    };

    return {
        terms,
        loading,
        fetchData,
        deleteTerm,
        toggleActive
    };
};




